import React from 'react';
import { useHistory } from "react-router-dom";
import './index.scss';

export default function UnsupportCityHolder() {
  const history = useHistory();

  // 跳转切换城市
  const onRoute2SwitchCity = () => {
    history.push(`${history.location.pathname}${history.location.search}#select-cities`);
  }
  
  return (
    <div className="unsupport-place-holder">
      <i className="place-holder-icon" />
      <span className="empty-desc">
        当前城市暂无服务门店  
      </span>
      <div className="action-field" onClick={onRoute2SwitchCity}>
        <span>切换其他城市</span>
        <i className="switch-icon" />
      </div>
    </div>
  )
}